import { IFields } from './FieldsModels'

export enum FormNames {
   BasicInfo = 'BasicInfo', 
   ExtendedInfoForm = 'ExtendedInfoForm',
   AddressInfoForm = 'AddressInfoForm',
   MObywatelExtendedInfoForm = 'MObywatelExtendedInfoForm',
   CollectPersonalIdForm = 'CollectPersonalIdForm',
}

export type TFormNames = keyof typeof FormNames;


export interface IFormDefinition {
   name: TFormNames;
   fields: IFields;
   labelTextContentPath: string;
   urlPath: string;
   canStepBack: boolean;
   subbmitButtonTextContentPath: string;
   descriptionTextContentPath?: string;

   nextStepUrlPath?: string;
   previousStepUrlPath?: string ;
}